// removed by extract-text-webpack-plugin
module.exports = {"container":"_2HKyHOW9iUyjz42fHvtSdP"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/OrgInformation/styles.css
// module id = 3178
// module chunks = 0